/**
 * Los centros en los que se puede pedir una reseña de Google.
 *
 * No están en el código: son una lista de Configuración (nombre y enlace de
 * cada centro), vacía por defecto. El servidor solo da el id y el nombre
 * (`/api/recordatorios/resena-centros`); el enlace lo pone él en el mensaje.
 * Sin ningún centro, las pantallas no ofrecen «Pedir reseña».
 */
import { useEffect, useState } from 'react';
import { api } from './api';

/**
 * Los centros de reseña, leídos cuando `activo` (el panel o el resumen de la
 * cita están abiertos). Si la lectura falla, lista vacía: mejor no ofrecer
 * el botón que ofrecer uno que va a contestar un error.
 */
export function useCentrosResena(activo = true) {
  const [centros, setCentros] = useState([]);
  useEffect(() => {
    if (!activo) return undefined;
    let vivo = true;
    api.get('/api/recordatorios/resena-centros')
      .then((r) => { if (vivo) setCentros(Array.isArray(r?.data?.centros) ? r.data.centros : []); })
      .catch(() => { if (vivo) setCentros([]); });
    return () => { vivo = false; };
  }, [activo]);
  return centros;
}
